const EI_ELIGIBILITY_BY_CLAIMANT_KEY = Object.freeze({
  "1": "EI Active Claim",
  claimant: "EI Active Claim",
  "active claimant": "EI Active Claim",
  "ei active claim": "EI Active Claim",
  "2": "EI Reach Back",
  "reach back": "EI Reach Back",
  "former claimant": "EI Reach Back",
  "ei reach back": "EI Reach Back",
  "3": "CRF",
  crf: "CRF",
  "non insured": "CRF",
});

const normalizeClaimantKey = value =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");

export const mapActionPlanEiClaimantToEligibility = value =>
  EI_ELIGIBILITY_BY_CLAIMANT_KEY[normalizeClaimantKey(value)] || "";

// Later interventions retain the Action Plan classification. Historical review
// metadata is evidence, not a replacement for the plan's established category.
export const resolveInterventionReviewEiEligibility = ({ actionPlanEiClaimant } = {}) =>
  mapActionPlanEiClaimantToEligibility(actionPlanEiClaimant);

export const getInterventionPlanFundingIssues = plan => {
  if (!plan?.id) return ["Select an existing Action Plan before approving."];
  const issues = [];
  const fundingStream = String(plan.fundingStream || plan.funding_stream || "").trim().toUpperCase();
  const classification = mapActionPlanEiClaimantToEligibility(plan.eiClaimant);
  if (!["EI", "CRF"].includes(fundingStream)) {
    issues.push("Complete the Action Plan funding stream before approving.");
  }
  if (!classification) {
    issues.push("Complete the Action Plan classification before approving.");
  } else if (["EI", "CRF"].includes(fundingStream) && fundingStream !== (classification === "CRF" ? "CRF" : "EI")) {
    issues.push("Correct the Action Plan classification and funding stream before approving.");
  }
  if (!String(plan.budgetPot || plan.budget_pot || "").trim()) {
    issues.push("Complete the Action Plan budget pot before approving.");
  }
  return issues;
};
